import clsx from 'clsx'
import { motion } from 'framer-motion'

import { useNaturalPowerRatio } from './NaturalPowerCalculatorProvider'

export function TraditionalPowerSource() {
  const naturalPowerRatio = useNaturalPowerRatio()
  const variants = {
    off: {
      x: 68,
      y: 30,
      scale: 0,
      opacity: 0.1,
    },
    on: {
      x: [68, 35, 30, 22, -20],
      y: [30, -15, -18, -20, -28],
      scale: [0, 0.9, 0.95, 1, 1.2],
      opacity: [0.1, 1, 1, 0.9, 0],
      transition: { duration: 3, repeat: Infinity, ease: 'linear', times: [0, 0.3, 0.35, 0.45, 1] },
    },
  }
  return (
    <div
      className={clsx(
        'absolute w-52 origin-bottom-right transition-all duration-300 ease-out',
        naturalPowerRatio === 0.0 && 'right-1/2 translate-x-1/2 scale-100 stroke-2',
        naturalPowerRatio === 0.25 && 'right-3/8 translate-x-3/8 scale-75 stroke-3',
        naturalPowerRatio === 0.5 && 'right-1/4 translate-x-1/4 scale-50 stroke-4',
        naturalPowerRatio === 0.75 && 'right-1/8 translate-x-1/8 scale-25 stroke-5',
        naturalPowerRatio === 1 &&
          'right-0 -translate-x-0 scale-0 stroke-6 opacity-0 duration-1000 rotate-12 -translate-y-1',
      )}>
      <motion.svg
        className={clsx(
          naturalPowerRatio === 0.0 && 'stroke-2',
          naturalPowerRatio === 0.25 && 'stroke-3',
          naturalPowerRatio === 0.5 && 'stroke-4',
          naturalPowerRatio === 0.75 && 'stroke-5',
          naturalPowerRatio === 1 && 'stroke-6',
        )}
        variants={variants}
        initial="off"
        animate={naturalPowerRatio === 1 ? 'off' : 'on'}
        width="50"
        height="26"
        viewBox="0 0 50 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M41.2581 25C43.3114 25 45.2805 24.2098 46.7324 22.8033C48.1843 21.3968 49 19.4891 49 17.5C49 15.5109 48.1843 13.6032 46.7324 12.1967C45.2805 10.7902 43.3114 10 41.2581 10C39.5109 10.0051 37.8177 10.5871 36.4581 11.65C36.1171 8.73249 34.6839 6.03727 32.4297 4.07462C30.1754 2.11196 27.2566 1.01807 24.2258 1C20.9405 1 17.7898 2.26427 15.4668 4.51471C13.1438 6.76515 11.8387 9.8174 11.8387 13C11.8429 13.7959 11.9259 14.5895 12.0865 15.37C11.5126 14.6384 10.7731 14.0442 9.92474 13.6333C9.07641 13.2224 8.14199 13.0057 7.19355 13C5.55092 13 3.97557 13.6321 2.81405 14.7574C1.65253 15.8826 1 17.4087 1 19C1 20.5913 1.65253 22.1174 2.81405 23.2426C3.97557 24.3679 5.55092 25 7.19355 25H41.2581Z"
          stroke="white"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </motion.svg>

      <svg viewBox="0 0 203 157" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M161.198 110.586V65.9385H44.124V81.5077M36.9058 119.437H16.3882V155.437H36.9058M36.9058 119.437V155.437M36.9058 119.437H57.4239V155.437H36.9058M177.349 37.5273V106.527M141.012 65.9391V37.5273M141.012 37.5309C141.006 35.1308 141.473 32.7533 142.384 30.5349C143.295 28.3166 144.633 26.3009 146.321 24.6038C148.009 22.9067 150.014 21.5616 152.22 20.6456C154.427 19.7296 156.791 19.2608 159.178 19.2662C161.566 19.2608 163.93 19.7296 166.137 20.6456C168.343 21.5616 170.348 22.9067 172.036 24.6038C173.724 26.3009 175.062 28.3166 175.973 30.5349C176.884 32.7533 177.35 35.1308 177.345 37.5309M177.349 73.4895C177.349 70.2601 178.625 67.1629 180.896 64.8794C183.167 62.5959 186.248 61.313 189.46 61.313C192.672 61.313 195.752 62.5959 198.024 64.8794C200.295 67.1629 201.571 70.2601 201.571 73.4895M201.568 71.7441V130.881M177.349 82.1758H201.571M141.012 45.6484H177.345M72.8118 96.0957L36.9059 78.2935L1 96.0957V155.436H72.8118V96.0957ZM52.1992 41.5854H76.4214V65.9384H52.1992V41.5854ZM58.2549 1H70.366V41.5882H58.2549V1ZM88.5308 41.5854H112.753V65.9384H88.5308V41.5854ZM94.5869 1H106.698V41.5882H94.5869V1ZM201.57 155.235V122.764L177.347 106.529V122.764L153.125 106.529V122.764L128.903 106.529V122.764L104.681 106.529V155.235H201.57ZM120.83 134.94H124.867V138.999H120.83V134.94ZM141.012 134.94H145.049V138.999H141.012V134.94ZM161.199 134.94H165.236V138.999H161.199V134.94ZM181.386 134.94H185.423V138.999H181.386V134.94ZM104.681 82.1758H145.051V94.3522H104.681V82.1758Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  )
}
